import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex py-xs w-full cursor-pointer" }
const _hoisted_2 = { class: "flex w-full lg:items-start" }
const _hoisted_3 = { class: "px-s flex-1 items-center justify-start flex" }
const _hoisted_4 = { class: "hidden lg:block" }
const _hoisted_5 = { class: "lg:hidden" }
const _hoisted_6 = {
  key: 0,
  class: "list-disc ml-m mt-xs"
}
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col items-center justify-center w-tag flex-grow-0 px-xs"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("small", { class: "hidden lg:block mb-xxs" }, " Neue Nachrichten ", -1)
const _hoisted_9 = { class: "hidden lg:flex flex-col items-center justify-center w-tag flex-grow-0 px-xs" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("small", { class: "mb-xxs" }, " Lieferdatum ", -1)
const _hoisted_11 = { class: "hidden lg:flex flex-col items-center justify-center w-tag flex-grow-0 px-xs" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("small", { class: "mb-xxs" }, " Status ", -1)
const _hoisted_13 = { class: "hidden lg:flex flex-col items-center justify-center w-tag flex-grow-0 px-xs" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("small", { class: "block mb-xxs" }, " Lieferungen ", -1)
const _hoisted_15 = { class: "flex flex-col items-center justify-center" }

import CoreIcon from "@/components/CoreIcon.vue";
import { Conversation } from "@/interfaces/conversation";
import { useSessionStore } from "@/store/sessionStore";
import { useOrdersStore } from "@/store/ordersStore";
import ProfileCircle from "@/components/ProfileCircle.vue";
import { newChatMessages } from "@/helpers/orderhelper";
import SmallTag from "@/components/SmallTag.vue";
import {
  getDeliveryStatusOfConversation,
  statusOfConversation,
} from "@/helpers/orderhelper";
import ProgressBlocks from "@/components/ProgressBlocks.vue";
import { CareProviderGroup } from "@/interfaces/careProviderGroup";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderRow',
  props: {
    conversation: {},
    notaTabActive: { type: Boolean }
  },
  setup(__props: any) {

const sessionStore = useSessionStore();
const ordersStore = useOrdersStore();

const props = __props;

const otherCpg = computed(() => {
  let otherCpg: CareProviderGroup | null = null;
  if (
    props.conversation.receiverCareProviderGroup.id ==
    sessionStore.selectedCareProviderGroup?.id
  ) {
    otherCpg = props.conversation.senderCareProviderGroup;
  } else {
    otherCpg = props.conversation.receiverCareProviderGroup;
  }
  return otherCpg;
});

const messages = computed(() => {
  return ordersStore.getMessages(props.conversation.id);
});

const notaMedications = computed(() => {
  return messages.value.filter(
    (msg) => msg.medication_order && msg.medication_order.status == 7
  );
});

const deliveryStatus = computed(() => {
  return getDeliveryStatusOfConversation(messages.value);
});

const conversationStatus = computed(() => {
  return statusOfConversation(props.conversation, messages.value);
});

const newChatMessagesComputedProp = computed(() => {
  return newChatMessages(props.conversation, messages.value);
});

function localeString(date: string) {
  return new Date(date).toLocaleDateString();
}

const progress = computed(() => {
  let boxes = messages.value.filter(
    (message) =>
      message.medication_box != null && !message.medication_box.deleted
  );
  boxes = boxes.sort(
    (a, b) => (b.medication_box?.status ?? 0) - (a.medication_box?.status ?? 0)
  );
  let result: string[] = [];
  for (let box of boxes) {
    if (box.medication_box == null) continue;
    if (box.medication_box?.status == 0) {
      result.push("gray");
    } else if (box.medication_box?.status == 4) {
      result.push("blue");
    } else if (box.medication_box?.status == 1) {
      result.push("orange");
    } else if (box.medication_box?.status == 2) {
      result.push("green");
    } else {
      result.push("red");
    }
  }
  return result;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ProfileCircle, { "care-provider-group": otherCpg.value }, null, 8, ["care-provider-group"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(props.conversation.decrypted_subject) + " vom " + _toDisplayString(localeString(
              props.conversation.orders_sent?.created_at ??
                props.conversation.created_at
            )) + " ", 1),
          _createElementVNode("small", _hoisted_4, _toDisplayString(props.conversation.senderCareProviderGroup.group_name) + " an " + _toDisplayString(props.conversation.receiverCareProviderGroup.group_name), 1),
          _createElementVNode("small", _hoisted_5, [
            _createVNode(SmallTag, {
              color: deliveryStatus.value ? 'green' : 'orange'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(deliveryStatus.value != undefined
                  ? localeString(deliveryStatus.value!.desc.toString())
                  : "Kein Lieferdatum"), 1)
              ]),
              _: 1
            }, 8, ["color"])
          ]),
          (props.notaTabActive)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notaMedications.value, (medication) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: medication.id
                  }, _toDisplayString(medication.medication_order?.amount) + "x " + _toDisplayString(medication.medication_order?.name), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (newChatMessagesComputedProp.value > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(SmallTag, { color: "green" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(newChatMessagesComputedProp.value), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(SmallTag, {
          color: deliveryStatus.value ? 'green' : 'orange'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(deliveryStatus.value != undefined
              ? localeString(deliveryStatus.value!.desc.toString())
              : "Kein Lieferdatum"), 1)
          ]),
          _: 1
        }, 8, ["color"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(SmallTag, {
          color: conversationStatus.value.color
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(conversationStatus.value.label), 1)
          ]),
          _: 1
        }, 8, ["color"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode(ProgressBlocks, { blocks: progress.value }, null, 8, ["blocks"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(CoreIcon, {
          icon: "more",
          class: "opacity-30"
        })
      ])
    ])
  ]))
}
}

})